module.exports = __webpack_public_path__ + "static/media/AvenirNext-Regular.d568cffb.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/AvenirNext-Regular.ttf
// module id = 81
// module chunks = 0